import {GET_GANT_REPRESENTATION} from "../../../enums/Employees/employees.types";

export const getGantRepresentationAction = (data) => {
    return {
        type: GET_GANT_REPRESENTATION,
        payload: data,
    };
};
